import { createFileRoute } from "@tanstack/react-router";
import AdminSetQuestionNewPage from "@/pages/admin/sets/detail/questions/new";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/questions/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms, userCanViewAllCriteria } = useSetsPermissions();

  return (
    <AdminSetQuestionNewPage
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanViewAllCriteria={userCanViewAllCriteria}
    />
  );
}
